/* ============================================================
   DOGS SUPREME · <ds-article-audio>
   Gekapseltes Custom Element fuer "Beitrag anhoeren".
   Look: Apple, hell (Storefront ist Hell-only, KEIN OS-Dark-Mode).

   Kompakte Pille, expandiert NUR waehrend Audio laeuft:
     · Ruhe/Pause -> "( ▶ ) Beitrag anhören" (kompakt, blauer Play-Kreis)
     · Aktiv      -> "( ⏸ ) [Scrubber] Zeit Tempo" (Controls, gedeckelt)
   Zweiter Klick klappt zurueck zum Ursprung (bis zur Ruhebreite, nicht weiter).

   Modi (Zustandsmaschine idle | playing | paused):
     · manual -> echte Audiodatei (Primaerpfad): Scrubber + Zeit + Media Session
     · auto   -> Browser-Vorlesen (Fallback): satzweise, Tempo, Fortschritt

   Kompatibilitaet: echte ES2015-class (Custom Elements + class ab iOS 10.3 / 2017),
   BEWUSST ohne private #-Felder (iOS 14.5), ohne Optional-Chaining, ohne CSS
   inset/min() -> laeuft auf praktisch jedem Endgeraet mit Custom-Elements-Support.
   Feature-Erkennung, graceful Degradation, reduced-motion/-transparency.
   ============================================================ */
(function () {
  'use strict';
  if (!('customElements' in window) || customElements.get('ds-article-audio')) return;

  var HAS_TTS = ('speechSynthesis' in window) && ('SpeechSynthesisUtterance' in window);
  var SPEEDS = [1, 1.25, 1.5, 1.75];
  var SKIP = 15;
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    t = Math.floor(t);
    var s = t % 60;
    return Math.floor(t / 60) + ':' + (s < 10 ? '0' + s : '' + s);
  }
  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }
  function trim(s) { return s.replace(/^\s+|\s+$/g, ''); }

  function injectStyles() {
    if (document.getElementById('ds-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'ds-audio-styles';
    style.textContent = [
      "ds-article-audio{",
      "--a:#007AFF;--a2:#0071EB;--on-a:#fff;--txt:#1d1d1f;--a-tint:rgba(0,122,255,.18);",
      "--lbl:rgba(60,60,67,.62);--fill:rgba(120,120,128,.22);--fill-press:rgba(120,120,128,.32);",
      "--pill:rgba(255,255,255,.86);--pill-bd:rgba(0,0,0,.07);--sh:0 4px 16px rgba(0,0,0,.10);",
      "--ff:-apple-system,'SF Pro Text','SF Pro Display',system-ui,sans-serif;",
      "display:flex;justify-content:center}",
      "ds-article-audio[hidden]{display:none}",
      "ds-article-audio *{box-sizing:border-box}",
      "ds-article-audio .ds-audio-panel{display:inline-flex;align-items:center;gap:10px;max-width:100%;position:relative;",
      "padding:5px 16px 5px 5px;margin-top:14px;font-family:var(--ff);",
      "transition:width .44s cubic-bezier(.32,.72,0,1);background:var(--pill);",
      "-webkit-backdrop-filter:blur(18px) saturate(150%);backdrop-filter:blur(18px) saturate(150%);",
      "border:.5px solid var(--pill-bd);border-radius:999px;box-shadow:var(--sh)}",
      "ds-article-audio[data-state=\"playing\"] .ds-audio-panel{width:380px;max-width:100%;padding-right:8px}",
      "ds-article-audio .ds-audio-btn{flex:0 0 auto;display:inline-flex;align-items:center;gap:10px;padding:0;margin:0;",
      "border:none;background:transparent;cursor:pointer;font-family:var(--ff);",
      "-webkit-tap-highlight-color:transparent;transition:opacity .15s,gap .3s cubic-bezier(.32,.72,0,1)}",
      "ds-article-audio[data-state=\"playing\"] .ds-audio-btn{gap:0}",
      "ds-article-audio .ds-audio-btn:active{opacity:.7}",
      "ds-article-audio .ds-audio-glyph{flex:0 0 auto;width:38px;height:38px;border-radius:50%;background:var(--a);color:var(--on-a);",
      "display:inline-flex;align-items:center;justify-content:center;",
      "transition:transform .2s cubic-bezier(.2,.7,.2,1),background .15s}",
      "ds-article-audio .ds-audio-btn:hover .ds-audio-glyph{background:var(--a2)}",
      "ds-article-audio .ds-audio-btn:active .ds-audio-glyph{transform:scale(.9)}",
      "ds-article-audio .ds-audio-btn:focus-visible{outline:none}",
      "ds-article-audio .ds-audio-btn:focus-visible .ds-audio-glyph{box-shadow:0 0 0 4px var(--a-tint)}",
      "ds-article-audio .ds-audio-glyph svg{width:19px;height:19px;display:block;fill:currentColor}",
      "ds-article-audio .ds-audio-label{font-size:15px;font-weight:600;letter-spacing:-.012em;color:var(--txt);white-space:nowrap;overflow:hidden;max-width:220px;transition:opacity .2s ease,max-width .36s cubic-bezier(.32,.72,0,1)}",
      "ds-article-audio[data-state=\"playing\"] .ds-audio-label{opacity:0;max-width:0}",
      "ds-article-audio .ds-audio-controls{display:flex;flex:1 1 auto;align-items:center;gap:10px;min-width:0;opacity:1;transition:opacity .3s ease .04s}",
      "ds-article-audio:not([data-state=\"playing\"]) .ds-audio-controls{position:absolute;left:50px;right:12px;top:0;bottom:0;opacity:0;pointer-events:none}",
      "ds-article-audio .ds-audio-track{flex:1 1 auto;min-width:56px;height:36px;display:flex;align-items:center;position:relative;cursor:pointer;touch-action:none}",
      "ds-article-audio[data-mode=\"auto\"] .ds-audio-track{cursor:default}",
      "ds-article-audio .ds-audio-line{position:relative;width:100%;height:5px;border-radius:999px;background:var(--fill)}",
      "ds-article-audio .ds-audio-fill{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:999px;background:var(--a);transition:width .1s linear}",
      "ds-article-audio .ds-audio-knob{position:absolute;top:50%;right:-6px;width:13px;height:13px;border-radius:50%;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,.3);transform:translate(0,-50%) scale(0);transition:transform .15s cubic-bezier(.2,.7,.2,1)}",
      "ds-article-audio[data-mode=\"manual\"][data-state=\"playing\"] .ds-audio-track:hover .ds-audio-knob,",
      "ds-article-audio[data-mode=\"manual\"][data-state=\"playing\"] .ds-audio-knob{transform:translate(0,-50%) scale(1)}",
      "ds-article-audio .ds-audio-track:focus-visible{outline:none}",
      "ds-article-audio .ds-audio-track:focus-visible .ds-audio-line{box-shadow:0 0 0 4px var(--a-tint)}",
      "ds-article-audio .ds-audio-time{flex:0 0 auto;font-size:12px;letter-spacing:-.01em;color:var(--lbl);white-space:nowrap;font-variant-numeric:tabular-nums}",
      "ds-article-audio .ds-audio-mini{flex:0 0 auto;-webkit-appearance:none;appearance:none;border:none;min-width:40px;height:28px;padding:0 10px;",
      "border-radius:999px;background:var(--fill);color:var(--a);font-family:var(--ff);font-size:12px;font-weight:700;",
      "font-variant-numeric:tabular-nums;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background .15s,transform .15s}",
      "ds-article-audio .ds-audio-mini:active{background:var(--fill-press);transform:scale(.94)}",
      "ds-article-audio .ds-audio-mini:focus-visible{outline:none;box-shadow:0 0 0 3px var(--a-tint)}",
      "ds-article-audio .ds-audio-sr{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}",
      "@media (prefers-reduced-transparency:reduce){ds-article-audio .ds-audio-panel{background:#fff;-webkit-backdrop-filter:none;backdrop-filter:none;border-color:rgba(0,0,0,.10)}}",
      "@media (prefers-reduced-motion:reduce){ds-article-audio .ds-audio-panel,ds-article-audio .ds-audio-controls,",
      "ds-article-audio .ds-audio-label,ds-article-audio .ds-audio-glyph,ds-article-audio .ds-audio-btn,",
      "ds-article-audio .ds-audio-fill,ds-article-audio .ds-audio-knob,ds-article-audio .ds-audio-mini{transition:none}}"
    ].join('');
    document.head.appendChild(style);
  }

  class DsArticleAudio extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.mode = this.getAttribute('source') || 'auto';
      this.url = this.getAttribute('src') || '';
      this.contentSelector = this.getAttribute('content') || '#DsArticleContent';
      this.trigger = this.querySelector('button') || this;
      this.rate = this._readRate();

      if (this.mode === 'manual' && !this.url) this.mode = HAS_TTS ? 'auto' : 'none';
      if (this.mode === 'auto' && !HAS_TTS) this.mode = 'none';
      if (this.mode === 'none') { this.hidden = true; return; }

      injectStyles();
      this.setAttribute('data-mode', this.mode);
      this.state = 'idle';
      this.setAttribute('data-state', 'idle');
      this._buildUI();
      this._wire();
      if (this.mode === 'manual') this._initManual(); else this._initAuto();
    }

    disconnectedCallback() { this._stop(); }

    /* -------- oeffentliche Steuerung -------- */
    toggle() { if (this.state === 'playing') this.pause(); else this.play(); }
    play() { if (this.mode === 'manual') this._playManual(); else this._playAuto(); }
    pause() { if (this.mode === 'manual') this.audio.pause(); else this._pauseAuto(); }

    /* -------- UI: kompakte Pille, blauer Play-Kreis -------- */
    _buildUI() {
      var play = this.trigger.querySelector('.ds-icon-play');
      var pause = this.trigger.querySelector('.ds-icon-pause');
      if (play && pause && !this.trigger.querySelector('.ds-audio-glyph')) {
        var glyph = document.createElement('span');
        glyph.className = 'ds-audio-glyph';
        this.trigger.insertBefore(glyph, this.trigger.firstChild);
        glyph.appendChild(play);
        glyph.appendChild(pause);
      }

      var panel = document.createElement('div');
      panel.className = 'ds-audio-panel';
      if (this.trigger !== this && this.trigger.parentElement === this) panel.appendChild(this.trigger);

      var controls = document.createElement('div');
      controls.className = 'ds-audio-controls';

      var track = document.createElement('div');
      track.className = 'ds-audio-track';
      track.tabIndex = this.mode === 'manual' ? 0 : -1;
      track.setAttribute('role', 'slider');
      track.setAttribute('aria-label', 'Fortschritt');
      track.setAttribute('aria-valuemin', '0');
      track.setAttribute('aria-valuemax', '100');
      track.setAttribute('aria-valuenow', '0');
      var line = document.createElement('div'); line.className = 'ds-audio-line';
      var fill = document.createElement('div'); fill.className = 'ds-audio-fill';
      var knob = document.createElement('div'); knob.className = 'ds-audio-knob';
      fill.appendChild(knob); line.appendChild(fill); track.appendChild(line);

      var time = document.createElement('span');
      time.className = 'ds-audio-time';
      time.textContent = this.mode === 'manual' ? '0:00' : '0 %';

      var speed = this._mini(this.rate + '×', 'Wiedergabetempo');

      controls.appendChild(track); controls.appendChild(time); controls.appendChild(speed);
      panel.appendChild(controls);

      var live = document.createElement('span');
      live.className = 'ds-audio-sr';
      live.setAttribute('aria-live', 'polite');

      this.appendChild(panel); this.appendChild(live);
      this.els = { panel: panel, controls: controls, track: track, fill: fill, time: time, speed: speed, live: live };
      this.trigger.setAttribute('aria-pressed', 'false');
      this._label();
      // Ruhebreite cachen (Ziel beim Einfahren, damit es nicht zu weit zusammenzieht)
      var self = this;
      raf(function () { self._compactW = panel.getBoundingClientRect().width; });
    }

    _mini(text, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-audio-mini';
      b.textContent = text;
      b.setAttribute('aria-label', label);
      return b;
    }

    _wire() {
      var self = this;
      this.trigger.addEventListener('click', function (e) { e.stopPropagation(); self.toggle(); });
      var proxies = document.querySelectorAll('[data-ds-audio-toggle]');
      for (var i = 0; i < proxies.length; i++) {
        proxies[i].addEventListener('click', function (e) { e.stopPropagation(); self.toggle(); });
      }
      this.els.speed.addEventListener('click', function (e) { e.stopPropagation(); self._cycleSpeed(); });
      if (this.mode === 'manual') this._wireScrub();
    }

    /* -------- Zustand / A11y / Fortschritt / Morph -------- */
    _setState(s) {
      var wasPlaying = this.state === 'playing';
      this.state = s;
      var playing = s === 'playing';
      this.trigger.setAttribute('aria-pressed', playing ? 'true' : 'false');
      var p = this.trigger.querySelector('.ds-icon-play');
      var q = this.trigger.querySelector('.ds-icon-pause');
      if (p) p.style.display = playing ? 'none' : 'block';
      if (q) q.style.display = playing ? 'block' : 'none';
      this._label();
      if ('mediaSession' in navigator) { try { navigator.mediaSession.playbackState = playing ? 'playing' : 'paused'; } catch (e) {} }
      this._morph(wasPlaying, playing);
    }
    _morph(wasPlaying, isPlaying) {
      var panel = this.els && this.els.panel;
      if (!panel) { this.setAttribute('data-state', this.state); return; }
      if (wasPlaying === isPlaying || reduceMotion()) { this.setAttribute('data-state', this.state); return; }
      var from = panel.getBoundingClientRect().width;
      panel.style.transition = 'none';
      this.setAttribute('data-state', this.state);
      // Ziel NICHT live messen (Label-Uebergang wuerde zu schmal messen):
      // kompakt = gecachte Ruhebreite, expandiert = min(380, verfuegbar).
      var to = isPlaying
        ? Math.min(380, this.clientWidth || from)
        : (this._compactW || panel.getBoundingClientRect().width);
      if (!to || Math.abs(to - from) < 1) { panel.style.transition = ''; return; }
      panel.style.overflow = 'hidden';
      panel.style.width = from + 'px';
      void panel.offsetWidth;
      panel.style.transition = '';
      raf(function () { panel.style.width = to + 'px'; });
      var done = function (e) {
        if (e.target === panel && e.propertyName === 'width') {
          panel.style.width = ''; panel.style.overflow = '';
          panel.removeEventListener('transitionend', done);
        }
      };
      panel.addEventListener('transitionend', done);
    }
    _label() {
      this.trigger.setAttribute('aria-label', this.state === 'playing' ? 'Vorlesen anhalten' : 'Beitrag anhören');
    }
    _announce(msg) { if (this.els) this.els.live.textContent = msg; }
    _progress(frac, label) {
      frac = Math.max(0, Math.min(1, frac || 0));
      this.els.fill.style.width = frac * 100 + '%';
      this.els.track.setAttribute('aria-valuenow', Math.round(frac * 100));
      if (label != null) this.els.time.textContent = label;
    }
    _readRate() {
      try { var r = parseFloat(localStorage.getItem('ds-audio-rate')); return SPEEDS.indexOf(r) !== -1 ? r : 1; }
      catch (e) { return 1; }
    }
    _cycleSpeed() {
      this.rate = SPEEDS[(SPEEDS.indexOf(this.rate) + 1) % SPEEDS.length];
      try { localStorage.setItem('ds-audio-rate', String(this.rate)); } catch (e) {}
      this.els.speed.textContent = this.rate + '×';
      if (this.mode === 'manual') this.audio.playbackRate = this.rate;
      else if (this.state === 'playing') { this._gen++; this.synth.cancel(); this._speak(this.i); }
    }
    _seek(delta) {
      if (this.mode !== 'manual' || !isFinite(this.audio.duration)) return;
      this.audio.currentTime = Math.max(0, Math.min(this.audio.duration, this.audio.currentTime + delta));
    }
    _stop() {
      this._gen = (this._gen || 0) + 1;   // pendendes onend entwerten (kein Weiter-Sprechen nach Removal)
      if (this.audio) this.audio.pause();
      if (this.synth) {
        try { this.synth.cancel(); } catch (e) {}
        // globalen onvoiceschanged-Handler loesen (sonst Leak: haelt das entfernte Element)
        if (this._onVoices && this.synth.onvoiceschanged === this._onVoices) this.synth.onvoiceschanged = null;
      }
    }

    /* ==================== MANUAL ==================== */
    _initManual() {
      var self = this;
      var a = new Audio();
      a.preload = 'metadata';
      a.src = this.url;
      a.playbackRate = this.rate;
      this.audio = a;
      a.addEventListener('loadedmetadata', function () { self._updateManual(); self._mediaPos(); });
      a.addEventListener('timeupdate', function () { self._updateManual(); self._mediaPos(); });
      a.addEventListener('play', function () { self._setState('playing'); self._announce('Wird abgespielt'); });
      a.addEventListener('pause', function () { if (!a.ended) self._setState('paused'); });
      a.addEventListener('ended', function () { self._setState('idle'); self._announce('Beitrag beendet'); });
      a.addEventListener('error', function () { self._setState('idle'); self._announce('Audio nicht verfügbar'); });
      this._mediaSession();
    }
    _playManual() {
      var self = this;
      var pr = this.audio.play();
      if (pr && pr.catch) pr.catch(function () { self._setState('idle'); });
    }
    _updateManual() {
      var a = this.audio, d = a.duration || 0;
      this._progress(d ? a.currentTime / d : 0, fmt(a.currentTime) + ' / ' + fmt(d));
    }
    _wireScrub() {
      var self = this, t = this.els.track, drag = false;
      function seekTo(x) {
        var a = self.audio;
        if (!a || !isFinite(a.duration)) return;
        var r = t.getBoundingClientRect();
        a.currentTime = Math.max(0, Math.min(1, (x - r.left) / r.width)) * a.duration;
        self._updateManual();
      }
      t.addEventListener('pointerdown', function (e) { drag = true; if (t.setPointerCapture) t.setPointerCapture(e.pointerId); seekTo(e.clientX); });
      t.addEventListener('pointermove', function (e) { if (drag) seekTo(e.clientX); });
      t.addEventListener('pointerup', function () { drag = false; });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { self._seek(SKIP); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { self._seek(-SKIP); e.preventDefault(); }
      });
    }
    _mediaSession() {
      if (!('mediaSession' in navigator)) return;
      var self = this, ms = navigator.mediaSession;
      try {
        if ('MediaMetadata' in window) {
          ms.metadata = new window.MediaMetadata({
            title: trim((document.title || 'Beitrag').replace(/\s*[|·–-].*$/, '')),
            artist: 'Dogs Supreme', album: 'Ratgeber'
          });
        }
        ms.setActionHandler('play', function () { self.play(); });
        ms.setActionHandler('pause', function () { self.pause(); });
        ms.setActionHandler('seekbackward', function (d) { self._seek(-((d && d.seekOffset) || SKIP)); });
        ms.setActionHandler('seekforward', function (d) { self._seek((d && d.seekOffset) || SKIP); });
        ms.setActionHandler('seekto', function (d) { if (d && d.seekTime != null) self.audio.currentTime = d.seekTime; });
      } catch (e) {}
    }
    _mediaPos() {
      if (!('mediaSession' in navigator)) return;
      var ms = navigator.mediaSession;
      if (!ms.setPositionState) return;
      var a = this.audio;
      if (!isFinite(a.duration) || a.duration <= 0) return;
      try { ms.setPositionState({ duration: a.duration, playbackRate: a.playbackRate || 1, position: Math.min(a.currentTime, a.duration) }); } catch (e) {}
    }

    /* ==================== AUTO (Vorlesen) ==================== */
    _initAuto() {
      var self = this;
      this.synth = window.speechSynthesis;
      this.queue = []; this.cum = []; this.total = 0; this.i = 0; this.voice = null;
      this._gen = 0;   // Generations-Token: entwertet verzoegerte onend nach cancel/restart
      this._pickVoice();
      this._onVoices = function () { self._pickVoice(); };
      if ('onvoiceschanged' in this.synth) this.synth.onvoiceschanged = this._onVoices;
      this._mediaSession();
    }
    _playAuto() {
      if (!this.queue.length) this._prepare();
      if (!this.queue.length) return;
      this._setState('playing');
      this._announce('Wird vorgelesen');
      this._gen++;
      this._speak(this.i);
    }
    _pauseAuto() {
      // Index-basiert + Generations-Token: verzoegertes onend nach cancel wird ignoriert
      this._gen++;
      try { this.synth.cancel(); } catch (e) {}
      this._setState('paused');
      this._announce('Angehalten');
    }
    _pickVoice() {
      var vs = (this.synth && this.synth.getVoices && this.synth.getVoices()) || [];
      var de = [];
      for (var i = 0; i < vs.length; i++) if (/^de[-_]/i.test(vs[i].lang)) de.push(vs[i]);
      de.sort(function (a, b) { return (b.localService ? 1 : 0) - (a.localService ? 1 : 0); });
      this.voice = de[0] || null;
      if (!this.voice) for (var j = 0; j < vs.length; j++) if (/^de/i.test(vs[j].lang)) { this.voice = vs[j]; break; }
    }
    _prepare() {
      // Mehrere Treffer in Dokumentreihenfolge: der abgetrennte Kurzantwort-Einstieg
      // (#DsArticleIntro) steht vor dem Artikeltext und wird mitgelesen (VG-2610-VCS76).
      var hosts = document.querySelectorAll(this.contentSelector);
      if (!hosts.length) return;
      var parts = [];
      for (var h = 0; h < hosts.length; h++) {
        var clone = hosts[h].cloneNode(true);
        var drop = clone.querySelectorAll('figure,figcaption,script,style,noscript,button,.ds-image-breakout');
        for (var i = 0; i < drop.length; i++) if (drop[i].parentNode) drop[i].parentNode.removeChild(drop[i]);
        parts.push(clone.textContent || '');
      }
      var text = trim(parts.join(' ').replace(/\s+/g, ' '));
      if (!text) return;

      var MAX = 220, q = [], buf = '';
      function flush() { if (buf) { q.push(buf); buf = ''; } }
      function push(part) {
        if (trim(buf + ' ' + part).length > MAX) { flush(); buf = part; }
        else buf = buf ? buf + ' ' + part : part;
      }
      function words(str) { flush(); var w = str.split(/\s+/); for (var k = 0; k < w.length; k++) if (w[k]) push(w[k]); }
      var units = text.match(/[^.!?…]+[.!?…]+|\S[^.!?…]*$/g) || [text];
      for (var u = 0; u < units.length; u++) {
        var sentence = trim(units[u]);
        if (!sentence) continue;
        if (sentence.length <= MAX) { push(sentence); continue; }
        flush();
        var pieces = sentence.match(/[^,;:]+[,;:]?/g) || [sentence];
        for (var pI = 0; pI < pieces.length; pI++) {
          var piece = trim(pieces[pI]);
          if (piece) { if (piece.length > MAX) words(piece); else push(piece); }
        }
      }
      flush();

      this.queue = q; this.cum = []; this.total = 0;
      for (var c = 0; c < q.length; c++) { this.cum[c] = this.total; this.total += q[c].length; }
      this.i = 0;
    }
    _speak(i) {
      var self = this;
      if (i >= this.queue.length) { this._finishAuto(); return; }
      this.i = i;
      var gen = this._gen;   // diese Utterance gehoert zu Generation gen
      var u = new window.SpeechSynthesisUtterance(this.queue[i]);
      u.lang = 'de-DE';
      if (this.voice) u.voice = this.voice;
      u.rate = this.rate;
      u.onstart = function () { self._progress(self.cum[i] / self.total, Math.round((self.cum[i] / self.total) * 100) + ' %'); };
      u.onend = function () { if (self.state === 'playing' && self._gen === gen) self._speak(i + 1); };
      u.onerror = function () { if (self.state === 'playing' && self._gen === gen) self._speak(i + 1); };
      try { this.synth.speak(u); } catch (e) { this._setState('idle'); }
    }
    _finishAuto() {
      this.i = 0;
      this._setState('idle');
      this._progress(1, '100 %');
      this._announce('Beitrag beendet');
    }
  }

  customElements.define('ds-article-audio', DsArticleAudio);
  window.addEventListener('pagehide', function () { if (HAS_TTS) { try { window.speechSynthesis.cancel(); } catch (e) {} } });
})();
